import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AllQuestions from '../AllData/AllQuestions';
import './../../pagescss/QuizDetailsPage.css';
import Loading from '../home/Loading';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';

const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""}${minutes}:${secs < 10 ? "0" : ""}${secs}`;
};

// Function to safely parse answers
const parseAnswers = (answers) => {
  if (Array.isArray(answers)) {
    return answers;
  }

  if (typeof answers === 'string') {
    try {
      const parsed = JSON.parse(answers);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Error parsing answers JSON:', error);
      return [];
    }
  }

  return [];
};

// Function to calculate submission statistics
const calculateSubmissionStats = (answers) => {
  const parsedAnswers = parseAnswers(answers);
  let totalMarks = 0;
  let totalCorrectAns = 0;
  let totalIncorrectAns = 0;
  let totalNotAns = 0;

  parsedAnswers.forEach((ans) => {
    if (ans.userAnswer === ans.correctAnswer) {
      totalMarks += 4;
      totalCorrectAns++;
    } else if (ans.userAnswer === "option1" || ans.userAnswer === "option2" || ans.userAnswer === "option3" || ans.userAnswer === "option4") {
      totalMarks -= 1;
      totalIncorrectAns++;
    } else {
      totalNotAns++;
    }
  });

  return {
    totalMarks,
    totalCorrectAns,
    totalIncorrectAns,
    totalNotAns,
    percentage: parsedAnswers.length > 0 ? Math.round((totalMarks * 100) / (parsedAnswers.length * 4)) : 0
  };
};

function QuizDetailsPage() {
  const [quizSubmissions, setQuizSubmissions] = useState([]);
      const [submissions, setSubmissions] = useState([]);
      

  const { quizId } = useParams();

  const filterByPhoneAllQuizSubmissions = submissions;
  const loading = false;
  const questions = AllQuestions;
  const [bookmarkedQuestions, setBookmarkedQuestions] = useState([]);
  const [questionsId, setQuestionsId] = useState([]);


    // Load bookmarks from localStorage
      useEffect(() => {
          const storedBookmarks = localStorage.getItem('questionBookmarks');
          if (storedBookmarks) {
              setBookmarkedQuestions(JSON.parse(storedBookmarks));
          }
        
      }, []);

  useEffect(() => {
        const saved = localStorage.getItem('quizSubmissions');
        const data = saved ? JSON.parse(saved) : [];
        setSubmissions(data);
    }, []);


  useEffect(() => {
    if (quizId && filterByPhoneAllQuizSubmissions.length > 0) {
      const filtered = filterByPhoneAllQuizSubmissions.filter(data => data.quizId === quizId);

      // Process submissions to ensure answers are arrays
      const processedSubmissions = filtered.map(submission => ({
        ...submission,
        answers: parseAnswers(submission.answers)
      }));

      setQuizSubmissions(processedSubmissions);

      const allQuestionIds = processedSubmissions.flatMap(submission =>
        submission.answers.map(answer => answer.questionId)
      );
      setQuestionsId([...new Set(allQuestionIds)]); // Remove duplicates
    } else {
      setQuizSubmissions([]);
      setQuestionsId([]);
    }
  }, [filterByPhoneAllQuizSubmissions, quizId]);


   const compareQuestionIds = (id1, id2) => {
        // Extract the actual ID string from both IDs
        const extractId = (id) => {
            if (typeof id === 'object' && id.$oid) {
                return id.$oid; // MongoDB ObjectId format
            }
            return id; // String format
        };

        return extractId(id1) === extractId(id2);
    };

    // Handle bookmark toggle with localStorage
    const handleBookmark = (questionId) => {

        const isBookmarked = bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, questionId) 
        );

        let updatedBookmarks;
        
        if (isBookmarked) {
            // Remove bookmark
            updatedBookmarks = bookmarkedQuestions.filter(
                bq => !(compareQuestionIds(bq.questionId, questionId) )
            );
        } else {
            // Add bookmark
            const newBookmark = {
                questionId: questionId, // Store the ID as-is (could be object or string)
                timestamp: new Date().toISOString()
            };
            updatedBookmarks = [...bookmarkedQuestions, newBookmark];
        }

        // Update localStorage and state
        localStorage.setItem('questionBookmarks', JSON.stringify(updatedBookmarks));
        setBookmarkedQuestions(updatedBookmarks);
    };

    const isQuestionBookmarked = (questionId) => {
        return bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, questionId) 
        );
    };





 


  // Function to render text with LaTeX
  const renderWithLatex = (text) => {
    if (!text) return null;

    // Check if text contains LaTeX patterns
    if (text.includes('$') || text.includes('\\')) {
      return <Latex>{text}</Latex>;
    }
    return text;
  };


   // Redirect only home page

  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    const handleBackButton = (event) => {
      event.preventDefault();
      
      navigate('/', { replace: true });
    };

    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);



  if (loading) {
    return <Loading message='Loading......' />;
  }

  return (
   
      <div className="quiz-details">

        <TopNavbar name="Mock Test Attempt Details" />
        <TopHeader name="Mock Test Attempt Details" />

        <div className="quiz-details__card">

          {quizSubmissions.length === 0 ? (
            <p className="quiz-details__empty">No mock test submissions found.</p>
          ) : (
            <ul className="submissions">
              {quizSubmissions.map((submission, submissionIndex) => {
                // Calculate stats for each submission
                const stats = calculateSubmissionStats(submission.answers);
                const answersArray = parseAnswers(submission.answers);

                return (
                  <li key={submission.submissionId || submission._id || submissionIndex} className="submission">
                    <div className="submission__header">
                      <div className="submission__info">
                        <p className="submission__text">
                          <span className="submission__label">Mock test :</span> {submission.quizName} mock test
                        </p>
                        <p className="submission__text">
                          <span className="submission__label">Submitted:</span> {submission.submittedAt}
                        </p>
                        <p className="submission__text">
                          <span className="submission__label">Time Taken:</span>   {formatTime(submission.timeTaken)}
                        </p>
                        
                      </div>
                      <div className="submission__info">
                        <p className="submission__text">
                          <span className="submission__label">Score:</span> {stats.totalMarks}/{answersArray.length * 4} ({stats.percentage}%)
                        </p>
                        <p className="submission__text">
                          <span className="submission__label">Correct:</span> {stats.totalCorrectAns}
                        </p>
                        <p className="submission__text">
                          <span className="submission__label">Incorrect:</span> {stats.totalIncorrectAns}
                        </p>
                        <p className="submission__text">
                          <span className="submission__label">Not Answered:</span> {stats.totalNotAns}
                        </p>
                      </div>
                    </div>

                    <div className="submission__actions">
                      <Link
                        to={`/quiz-restarting/${submission.quizName}/${quizId}/${submission._id || submission.submissionId}`}
                        className="remock-test-link"
                      >
                         
                      </Link>
                    </div>

                    <h3 className="submission__questions-title">
                      Questions and Answers
                    </h3>

                    <ul className="questions">
                      {answersArray.map((answer, ansIndex) => {
                        if (!answer) return null; // Skip null answers

                        const questionId = answer.questionId;
                        const correctAns = answer.correctAnswer;
                        const userAns = answer.userAnswer;
                        let correctAnswer = "Not answered";
                        let userAnswer = "Not answered";

                        const questionData = questions.find(q => q._id.$oid === questionId);
                        const isData = !!questionData;
                        const photo = isData ? questionData.question_img : null;
                        const questinsId = isData ? questionData._id.$oid : null;

                        // Get correct answer text
                        if (correctAns === "option1") {
                          correctAnswer = isData ? questionData.option1 : correctAns;
                        } else if (correctAns === "option2") {
                          correctAnswer = isData ? questionData.option2 : correctAns;
                        } else if (correctAns === "option3") {
                          correctAnswer = isData ? questionData.option3 : correctAns;
                        } else if (correctAns === "option4") {
                          correctAnswer = isData ? questionData.option4 : correctAns;
                        }

                        // Get user answer text
                        if (userAns === "option1") {
                          userAnswer = isData ? questionData.option1 : userAns;
                        } else if (userAns === "option2") {
                          userAnswer = isData ? questionData.option2 : userAns;
                        } else if (userAns === "option3") {
                          userAnswer = isData ? questionData.option3 : userAns;
                        } else if (userAns === "option4") {
                          userAnswer = isData ? questionData.option4 : userAns;
                        }

                        return (
                          <li key={`${submission.submissionId}-${ansIndex}`} className={`question ${answer.isCorrect ? 'question--correct' : 'question--incorrect'}`}>
                           

                               
                                         <p>Id: {questinsId}</p>            

                            {photo ? (
                              <div className="question__image-container">
                                <img
                                  src={`/questionsPhoto/${photo}`}
                                  alt="Question"
                                  className="question__image"
                                />
                              </div>
                            ) : (
                              <p className="question__text">
                                <span className="question__number">{ansIndex + 1}.</span> {renderWithLatex(answer.questionText)}
                              </p>
                            )}

                            <div className="question__answers">
                              <div className="answer">
                                <p className="answer__label">Your Answer:</p>
                                <p className={`answer__text answer__text--user ${answer.isCorrect ? 'answer__text--correct' : 'answer__text--incorrect'}`}>
                                  {renderWithLatex(userAnswer)}
                                </p>
                              </div>
                              <div className="answer">
                                <p className="answer__label">Correct Answer:</p>
                                <p className="answer__text answer__text--correct">
                                  {renderWithLatex(correctAnswer)}
                                </p>
                                
                                <Link to={`/question-solution/${questionId}`} className="question__solution-link">
                                  View Solution {}

                                </Link>
                              </div>
                            </div>
                                       <br></br>
                          
                            <p className={`question__status ${answer.isCorrect ? 'question__status--correct' : 'question__status--incorrect'}`}>
                              {answer.isCorrect ? "✓ Correct" : "✗ Incorrect"}
                            </p>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
   
  );
}

export default QuizDetailsPage;